module.exports = __webpack_public_path__ + "img/big_1_26.acccf785.png";